module.exports = __webpack_public_path__ + "img/logo.99798e30.png";